export default __webpack_public_path__ + "static/media/exit-old-staking.1a4067da.png";